const BulkIgnoreModalContent = ({
  count,
  action,
}: {
  count: number;
  action: "ignore" | "include";
}) =>
  action === "include" ? (
    <p>
      You are about to include {count} pages back into crawling. Once included,
      the pages will be added to the crawl queue and processed according to your
      crawl settings. All applicable automations will be re-enabled.
    </p>
  ) : (
    <p>
      You are going to ignore {count} pages for further crawling. When ignoring
      pages all automations will be removed. You can always reenable crawling
      for the ignored pages.
    </p>
  );

export default BulkIgnoreModalContent;
